export const ACCEPT = 'Accept';
export const CANCEL = 'Cancel';

export const PROJECT_CREATED_TITLE = 'Project Created';
export const PROJECT_CREATED_MESSAGE = 'Project Created Succesfully';
export const PROJECT_EDITED_TITLE = 'Project Edited'
export const PROJECT_EDITED_MESSAGE = 'Project Edited Succesfully';

// Project Form titles and placeholders
export const PROJECT_NAME_LABEL = 'Project Name';
export const PROJECT_NAME_PLACEHOLDER = 'Project Name';
export const PROJECT_DESCRIPTION_LABEL = 'Description';
export const PROJECT_DESCRIPTION_PLACEHOLDER = 'Project description';
export const PROJECT_MANAGER_LABEL = 'Project Manager';
export const PROJECT_MANAGER_PLACEHOLDER = 'Select Project Manager';
export const PROJECT_ASSIGNEDTO_LABEL = 'Assign To';
export const PROJECT_ASSIGNEDTO_PLACEHOLDER = 'Assign to ...';
export const PROJECT_STATUS_LABEL = 'Status';
export const PROJECT_STATUS_MESSAGE = 'Select initial Status';